import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Flag } from 'lucide-react';

// Asks why a post is being reported. Portalled to the body, and clicks are
// stopped so they don't reach the card underneath (which opens the post).
const ReportPostDialog = ({ busy, onSubmit, onCancel }) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onCancel();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onCancel]);

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-[9000] flex items-center justify-center bg-gray-900/40 p-4"
      onClick={(e) => {
        e.stopPropagation();
        onCancel();
      }}>
      <form
        role="dialog"
        aria-modal="true"
        aria-labelledby="report-post-title"
        className="w-full max-w-sm rounded-panel bg-surface p-6 shadow-lg"
        onClick={(e) => e.stopPropagation()}
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(reason.trim());
        }}>
        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-danger-bg text-danger-fg">
          <Flag size={20} />
        </span>
        <h2 id="report-post-title" className="mt-4 text-base font-semibold text-gray-900">
          Report this post?
        </h2>
        <p className="mt-1.5 text-sm text-gray-600">
          Your company admins will see the report. The author isn&apos;t told who reported it.
        </p>
        <textarea
          autoFocus
          value={reason}
          onChange={(e) => setReason(e.target.value.slice(0, 1000))}
          rows={3}
          placeholder="What's wrong with it? (optional)"
          className="mt-4 w-full resize-none rounded-control border border-hairline px-3 py-2 text-sm outline-none focus:border-brand-600"
        />
        <div className="mt-5 flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-control border border-hairline-strong px-4 py-2 text-sm font-medium text-gray-700 hover:bg-surface-sunken">
            Cancel
          </button>
          <button
            type="submit"
            disabled={busy}
            className="rounded-control bg-danger px-4 py-2 text-sm font-medium text-white shadow-sm hover:opacity-90 disabled:opacity-60">
            Report
          </button>
        </div>
      </form>
    </div>,
    document.body
  );
};

export default ReportPostDialog;
